import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IAccessory;

const accessorySlice = createSlice({
    name: "accessory",
    initialState,
    reducers: {
        setAccessory: (state, action: PayloadAction<IAccessory | undefined>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setAccessory } = accessorySlice.actions;
export default accessorySlice.reducer;

export const getAccessory = (state: RootState) => state.accessory;
